const sizes = ['1', '2', '3', '4', '5'];
const variants = ['surface', 'classic', 'ghost'];
const cardPropDefs = {
    size: { type: 'enum', values: sizes, default: '1', responsive: true },
    variant: { type: 'enum', values: variants, default: 'surface' },
};
export { cardPropDefs };
//# sourceMappingURL=card.props.js.map